var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 177,
    viewBox: "0 0 183 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0298 94.8036H28.2705V83.324H21.0298C21.7194 62.7997 35.5113 21.9599 85.162 22.7948C85.162 57.025 85.8516 125.416 86.1964 155.333C67.2326 156.028 27.6499 144.897 21.0298 94.8036ZM72.7136 37.3884V140.756C65.1672 139.06 48.0559 131.739 38.5961 115.89C38.1167 115.087 37.8832 114.164 37.8832 113.229V63.9756C37.8832 62.9699 38.1498 61.9906 38.7088 61.1545C43.6226 53.8051 56.0152 40.5349 72.7136 37.3884Z",
    fill: "#A100FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2534 6.06991L91.3919 6.06991L91.5303 6.06352C111.05 5.16177 132.468 14.1247 149.11 29.7644C165.696 45.3506 177 67.0691 177 91C177 118.506 167.516 138.253 152.513 151.209C137.38 164.278 115.973 171 91.2534 171C42.8425 171 6 136.473 6 88.2872C6 63.8521 14.4766 43.4028 29.109 29.0646C43.7459 14.722 64.9787 6.0699 91.2534 6.06991Z",
    stroke: "#A100FF",
    strokeWidth: 12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0926 155.491L96.2051 23.0375C131.438 22.6685 157.277 56.3602 159.161 77.7573C158.113 77.7682 153.918 77.7301 145.529 77.818C139.83 50.9379 117.63 39.9372 110.275 38.6C110.516 61.5793 110.276 112.539 110.56 139.69C140.716 135.132 144.593 109.917 145.616 97.3179C145.966 97.3142 149.182 97.3625 159.248 97.2571C156.417 147.352 116.667 155.286 97.0926 155.491Z",
    fill: "#A100FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcLogo);
export default __webpack_public_path__ + "static/media/DC_Logo.064152af4b0a485665301fc87929f800.svg";
export { ForwardRef as ReactComponent };